// extracted by mini-css-extract-plugin
module.exports = {"field":"styles-module--field--3FxQP","captcha":"styles-module--captcha--3mCkc","label":"styles-module--label--2IYnK"};